import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetExamsAuthorizedPrePassword,
	GetExamsAuthorizedPrePasswordParams,
	GetExamsAuthorizedPrePasswordModel,
} from 'domain/usecases';

export class RemoteGetExamsAuthorizedPrePassword implements GetExamsAuthorizedPrePassword {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsAuthorizedPrePasswordModel>,
	) {}

	async post(
		params: GetExamsAuthorizedPrePasswordParams,
	): Promise<GetExamsAuthorizedPrePasswordModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
